import {
  groupInput,
  input,
  InputProvider,
  nonEmptyValidator,
} from "@redotech/ui/form";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";

export const OnTracCarrierInput = groupInput({
  apiId: input<string>({ validator: nonEmptyValidator }),
  apiKey: input<string>({ validator: nonEmptyValidator }),
  facility: input<string>({ validator: nonEmptyValidator }),
  injectionCity: input<string>({ validator: nonEmptyValidator }),
  injectionContact: input<string>({ validator: nonEmptyValidator }),
  injectionCountry: input<string>({ validator: nonEmptyValidator }),
  injectionFacilityCode: input<string>({ validator: nonEmptyValidator }),
  injectionInstruction: input<string>({ validator: nonEmptyValidator }),
  injectionPhone: input<string>({ validator: nonEmptyValidator }),
  injectionState: input<string>({ validator: nonEmptyValidator }),
  injectionStreet1: input<string>({ validator: nonEmptyValidator }),
  injectionStreet2: input<string>({}),
  injectionZip: input<string>({ validator: nonEmptyValidator }),
  pickupType: input<string>({ validator: nonEmptyValidator }),
});

export type OnTracCarrierValue = InputProvider.Value<typeof OnTracCarrierInput>;

export type OnTracCarrierForm = InputProvider.Form<typeof OnTracCarrierInput>;

export const OnTracCarrierDefault = (): OnTracCarrierValue => ({
  apiId: "",
  apiKey: "",
  facility: "",
  injectionCity: "",
  injectionContact: "",
  injectionCountry: "",
  injectionFacilityCode: "",
  injectionInstruction: "",
  injectionPhone: "",
  injectionState: "",
  injectionStreet1: "",
  injectionStreet2: "",
  injectionZip: "",
  pickupType: "",
});

export const CreateOnTracCarrierForm = memo(function CreateOnTracCarrierForm({
  carrierInput,
}: {
  carrierInput: OnTracCarrierForm;
}) {
  return (
    <>
      <RedoTextInput
        label="API ID"
        placeholder=""
        setValue={carrierInput.inputs.apiId.setValue}
        value={carrierInput.inputs.apiId.value}
      />
      <RedoTextInput
        label="API key"
        placeholder=""
        setValue={carrierInput.inputs.apiKey.setValue}
        value={carrierInput.inputs.apiKey.value}
      />
      <RedoTextInput
        label="Customer branch"
        placeholder=""
        setValue={carrierInput.inputs.facility.setValue}
        value={carrierInput.inputs.facility.value}
      />
      <RedoTextInput
        label="Tender at address contact"
        placeholder=""
        setValue={carrierInput.inputs.injectionContact.setValue}
        value={carrierInput.inputs.injectionContact.value}
      />
      <RedoTextInput
        label="Tender at address street 1"
        placeholder=""
        setValue={carrierInput.inputs.injectionStreet1.setValue}
        value={carrierInput.inputs.injectionStreet1.value}
      />
      <RedoTextInput
        label="Tender at address street 2"
        placeholder=""
        setValue={carrierInput.inputs.injectionStreet2.setValue}
        value={carrierInput.inputs.injectionStreet2.value}
      />
      <RedoTextInput
        label="Tender at address city"
        placeholder=""
        setValue={carrierInput.inputs.injectionCity.setValue}
        value={carrierInput.inputs.injectionCity.value}
      />
      <RedoTextInput
        label="Tender at address state"
        placeholder=""
        setValue={carrierInput.inputs.injectionState.setValue}
        value={carrierInput.inputs.injectionState.value}
      />
      <RedoTextInput
        label="Tender at address postal code"
        placeholder=""
        setValue={carrierInput.inputs.injectionZip.setValue}
        value={carrierInput.inputs.injectionZip.value}
      />
      <RedoTextInput
        label="Tender at address country code"
        placeholder=""
        setValue={carrierInput.inputs.injectionCountry.setValue}
        value={carrierInput.inputs.injectionCountry.value}
      />
      <RedoTextInput
        label="Tender at address phone"
        placeholder=""
        setValue={carrierInput.inputs.injectionPhone.setValue}
        value={carrierInput.inputs.injectionPhone.value}
      />
      <RedoTextInput
        label="Tender at address instruction"
        placeholder=""
        setValue={carrierInput.inputs.injectionInstruction.setValue}
        value={carrierInput.inputs.injectionInstruction.value}
      />
      <RedoTextInput
        label="Pickup type"
        placeholder=""
        setValue={carrierInput.inputs.pickupType.setValue}
        value={carrierInput.inputs.pickupType.value}
      />
      <RedoTextInput
        label="Facility code"
        placeholder=""
        setValue={carrierInput.inputs.injectionFacilityCode.setValue}
        value={carrierInput.inputs.injectionFacilityCode.value}
      />
    </>
  );
});
